// @flow
import styled from "styled-components";

export const Link = styled.a`
    font-size: 12px;
    color: #757575;
`;



// WEBPACK FOOTER //
// ./src/home-page-view/no-user-view/styled.js